var _defs, _g, _g2, _g3, _g4, _g5, _g6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTeam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.662,
    height: 23.465,
    viewBox: "0 0 27.662 23.465",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#579ffb;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.529 12.668)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M400.633,273.32h-2.139a5.566,5.566,0,0,1,.337,1.913v8.085a2.383,2.383,0,0,1-.137.8h3.537a2.4,2.4,0,0,0,2.4-2.4v-4.408A4,4,0,0,0,400.633,273.32Z",
    transform: "translate(-398.494 -273.32)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 12.668)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M5.8,275.234a5.564,5.564,0,0,1,.337-1.913H3.993A4,4,0,0,0,0,277.314v4.408a2.4,2.4,0,0,0,2.4,2.4H5.933a2.385,2.385,0,0,1-.137-.8Z",
    transform: "translate(0 -273.321)"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.392 10.588)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M145.713,234.815h-4.891a4,4,0,0,0-3.993,3.993v8.085a.8.8,0,0,0,.8.8h11.28a.8.8,0,0,0,.8-.8v-8.085A4,4,0,0,0,145.713,234.815Z",
    transform: "translate(-136.829 -234.815)"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.029 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M171.916,38.84a4.8,4.8,0,1,0,4.8,4.8A4.808,4.808,0,0,0,171.916,38.84Z",
    transform: "translate(-167.114 -38.84)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.807 4.476)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M37.034,121.689a3.59,3.59,0,1,0,3.591,3.591A3.6,3.6,0,0,0,37.034,121.689Z",
    transform: "translate(-33.443 -121.689)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.672 4.476)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M349.2,121.689a3.591,3.591,0,1,0,3.591,3.591A3.6,3.6,0,0,0,349.2,121.689Z",
    transform: "translate(-345.607 -121.689)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeam);
export default __webpack_public_path__ + "static/media/team.fc3ac9f4354e720783321051a4199a8e.svg";
export { ForwardRef as ReactComponent };